import { handleActions } from 'redux-actions'
import { defineAction } from 'redux-define'
import { fetchCorporateSession } from 'api'
import get from 'lodash/get'

const initialState = {
  employee_id: '',
  id: '',
  account_id: '',
  claimable_amount: '',
  created_at: '',
  updated_at: '',
  status: '',
  last_session: null,
  isLoading: false,
}

const TYPES = ['FAILURE', 'SUCCESS', 'REQUEST']

const FETCH_CORPORATE_SESSION_STATE = defineAction(
  'FETCH_CORPORATE_SESSION_STATE',
  TYPES,
  'unicorn/corporate_session',
)

export const setLastCorporateSessionId = (corporateSessionId) => ({
  type: 'SET_LAST_CORPORATE_SESSION_ID',
  payload: corporateSessionId,
})

export const fetchCorporateSessionState = () => async (dispatch) => {
  try {
    dispatch({ type: FETCH_CORPORATE_SESSION_STATE.REQUEST })

    const corporateSession = await fetchCorporateSession()

    dispatch({
      type: FETCH_CORPORATE_SESSION_STATE.SUCCESS,
      payload: corporateSession,
    })

    return corporateSession
  } catch (err) {
    dispatch({
      type: FETCH_CORPORATE_SESSION_STATE.FAILURE,
    })
  }
}

export default handleActions(
  {
    [FETCH_CORPORATE_SESSION_STATE.REQUEST]: (state) => ({
      ...state,
      isLoading: true,
    }),
    [FETCH_CORPORATE_SESSION_STATE.SUCCESS]: (state, { payload }) => {
      return {
        ...state,
        ...payload,
        isLoading: false,
      }
    },
    [FETCH_CORPORATE_SESSION_STATE.FAILURE]: (state) => ({
      ...state,
      isLoading: false,
    }),
    ['SET_LAST_CORPORATE_SESSION_ID']: (state, { payload }) => {
      return {
        ...state,
        last_session: payload,
      }
    },
  },
  initialState,
)
